import { useState } from "react";

export const useForm = (initialValues) => {
  const [values, setValues, resetValues] = useState(initialValues);

  return [
    values,
    (e) => {
      setValues({
        ...values,
        [e.target.name]: e.target.value,
      });
    },
    (e) => {
      setValues(initialValues);
    },
  ];
};
